'use es6';

export const getRecaptchaWidgetId = state => state.recaptcha.widgetId;
export const getRecaptchaToken = state => state.recaptcha.token;